import * as Yup from 'yup';

export const declineOrderFormSchema = Yup.object().shape({
  text: Yup
    .string()
    .trim()
    .required('This field may not be blank')
    .default(''),
});
